// extracted by mini-css-extract-plugin
export default {"image":"zZ-z","loaded":"AZ-z"};